
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/form-helper-text",
      function () {
        return require("private-next-pages/joy-ui/api/form-helper-text.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/form-helper-text"])
      });
    }
  